/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
import { UserEvaluationSurveyAnswerDto } from './user-evaluation-survey-answer-dto';
 /**
 *
 *
 * @export
 * @interface UserEvaluationSurveyDto
 */
export interface UserEvaluationSurveyDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof UserEvaluationSurveyDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof UserEvaluationSurveyDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof UserEvaluationSurveyDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof UserEvaluationSurveyDto
     */
    deleted: string | null;

    /**
     * @type {number}
     * @memberof UserEvaluationSurveyDto
     */
    nTime: number;

    /**
     * @type {string}
     * @memberof UserEvaluationSurveyDto
     */
    value: string | null;

    /**
     * @type {any}
     * @memberof UserEvaluationSurveyDto
     */
    metadata: any | null;

    /**
     * @type {JoinEntityDto}
     * @memberof UserEvaluationSurveyDto
     */
    user: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof UserEvaluationSurveyDto
     */
    professional: JoinEntityDto | null;

    /**
     * @type {JoinEntityDto}
     * @memberof UserEvaluationSurveyDto
     */
    survey: JoinEntityDto;

    /**
     * @type {Array<UserEvaluationSurveyAnswerDto>}
     * @memberof UserEvaluationSurveyDto
     */
    answers: Array<UserEvaluationSurveyAnswerDto>;
}
